
import styled from 'styled-components';

import CrossAppMessagingIntro from '../components/CrossAppMessaging/CrossAppMessagingIntro';
import MessagingChallangesSolutions from '../components/CrossAppMessaging/MessagingChallangesSolutions';
import HowItWorks from '../components/CrossAppMessaging/HowItWorks';
import CriticalMoment from '../components/CrossAppMessaging/CriticalMoment';
import FragmentedMessaging from '../components/CrossAppMessaging/FragmentedMessaging';
import GetStartedRequestDemoSide from '../components/generic/GetStartedRequestDemoSide';
import TrackingComponent from '../components/Tracking/TrackingComponent';
import { lightThemeColors } from '../assets/style/colors';
import { ReactComponent as GridAssetIcon } from "../assets/decorations/redBannerGridMarketingBottom.svg";
import { Helmet } from 'react-helmet-async';

const CrossAppMessaging = () => {


    return (
        <>
            <Helmet>
                <title>Grovs Cross-App Messaging | Unified Alerts for Web & Mobile</title>
                <meta
                    name="description"
                    content="Grovs lets you send seamless, branded alerts across mobile and web. No more missed messages or fragmented systems—just better user engagement and communication."
                />
                <meta
                    name="keywords"
                    content="cross-app messaging, in-app messaging, unified notifications, mobile web alerts, user engagement, branded alerts, app messaging platform, Grovs messaging"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Grovs Cross-App Messaging | Unified Alerts Across Devices" />
                <meta
                    property="og:description"
                    content="Connect with users through in-app, push, and inbox notifications—consistently and seamlessly. Grovs helps reduce missed alerts and boost engagement."
                />
                <meta property="og:url" content="https://www.grovs.io/messaging" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Grovs Messaging | Seamless, Branded Communication Across Platforms" />
                <meta
                    name="twitter:description"
                    content="Eliminate missed alerts and fragmented communication. Grovs unifies your messaging across platforms for maximum impact and engagement."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />
            </Helmet>
            <Container>
                <CrossAppMessagingIntro />
                <FragmentedMessaging />
                <MessagingChallangesSolutions />
                <HowItWorks />
                <CriticalMoment />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.crossAppMessagingBg}
                    gradientColor={"rgba(115, 5, 5, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{ color: lightThemeColors.darkColor, background: lightThemeColors.lightColor }}
                    outlineButtonVariant={lightThemeColors.lightColor}

                    title={"Ready to Solve Your App Growth Challenges?"}
                    subtitle={"Grovs helps your team clearly track performance, engage users effectively, and confidently optimize marketing strategies."}
                />
                <TrackingComponent />
            </Container>
        </>
    )
}

export default CrossAppMessaging
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
